// Module
var code = "<a class=\"search-again tabbable-links link-icon\" tabindex=\"0\"><icon-refresh class=\"icon-refresh\"></icon-refresh> Search Again</a> ";
// Exports
module.exports = code;